import { post,get } from "../ajax";

export async function Login(account:{userNameOrMobile:string,password:string}){
    const url = `/api/Account/LoginByPassword`
    const res = await post(url,account)
    return res;
}

export async function loginState(){
    const url = `/api/Account/GetLoginState`
    const res = await get(url)
    return res;
}

export async function merchantList(PageIndex:number,PageSize:number=15,Name:string){
    const url = `/api/Account/GetUserAccountMerchantList?PageIndex=${PageIndex}&PageSize=${PageSize}&Name=${Name}`
    const res = await get(url)
    return res;
}

export async function switchMerchant(merchantId:number){
    const url = `/api/Account/SwitchMerchant`
    const res = await post(url,{merchantId})
    return res;
}

export async function resetPassword(body:{
    mobile: string,
    verificationCode: string,
    password: string
  }){
    const url = `/api/Account/ResetPassword`
    const res = await post(url,body)
    return res;
}

export async function sendVerificationCode(body:{mobile: string}){
    const url = `/api/Account/SendMobileVerificationCode`
    const res = await post(url,body)
    return res;
}
